import { BaseError } from '@dynamic-labs-sdk/client';

type TransactionBroadcastFailedErrorParams = {
  response: Response;
};

export class TransactionBroadcastFailedError extends BaseError {
  public readonly response: Response;

  constructor({ response }: TransactionBroadcastFailedErrorParams) {
    super({
      cause: null,
      code: 'transaction_broadcast_failed_error',
      details: `Status: ${response.status} ${response.statusText}`,
      docsUrl: null,
      name: 'TransactionBroadcastFailedError',
      shortMessage: 'Failed to broadcast transaction to mempool',
    });

    this.response = response;
  }
}
